import { twMerge } from "tailwind-merge";
import Nudge from "../../common/components/Nudge";
import IpoDescription from "./IpoDescription";

interface IpoTitleProps {
  ipoTitle: string;
  ipoDescription?: string;
  defaultVariant?: string | boolean;
  mainboardCount?: number;
  smeCount?: number;
  ipoType?: string;
  customClass?: string;
  headingLevel?: string;
}

export default function IpoTitle({
  ipoTitle,
  ipoDescription,
  defaultVariant = true,
  mainboardCount,
  smeCount,
  ipoType,
  customClass = "",
  headingLevel,
}: IpoTitleProps) {

  // Convert string "true"/"false" from AEM to boolean
  const isDefaultVariant = typeof defaultVariant === "string" 
    ? defaultVariant === "true" 
    : defaultVariant ?? true;

  const baseClasses =
    "ipo-title-with-description__content flex flex-col gap-[4px] max-w-[892px]";
  const variantClasses =
    isDefaultVariant ? "border-b border-[#cccccc] px-4 py-3" : "";
  const CLOSED_IPO = "closed";
  const HeadingTag = headingLevel === "h2" ? "h2" : "h1";

  const finalMainboardCount = mainboardCount ?? 0;
  const finalSmeCount = smeCount ?? 0;
  return (
    <div className={twMerge(baseClasses, variantClasses, customClass)}>
      <div className="h-[21px] md:h-6 flex items-center gap-[6px]">
        <HeadingTag className="font-medium font-rubik ipo-title text-[18px] md:text-[20px] leading-none  text-[#1A1A1A]">
          {ipoTitle}
        </HeadingTag>
        {(finalMainboardCount > 0 && ipoType != CLOSED_IPO) && 
          <Nudge count={finalMainboardCount} className={`mainboard-nudge-value ${finalMainboardCount === 0 ? "hidden" : ""} 
          ${ipoType === "upcoming" ? "bg-[#1778eb]" : ""}`}/>}
        {(finalSmeCount > 0 && ipoType != CLOSED_IPO) && 
          <Nudge count={finalSmeCount} className={`sme-nudge-value ${finalMainboardCount > 0 ? "hidden" : ""} 
          ${ipoType === "upcoming" ? "bg-[#1778eb]" : ""}`}/>}
      </div>
      <IpoDescription ipoTitle={ipoTitle} ipoDescription={ipoDescription} />
    </div>
  );
}